

















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import SubjectMoreVue from "./SubjectMore.vue";
let newListItem: any;
@Component({
    components: {
        "subject-more": SubjectMoreVue
    }
})
export default class MatchSubject extends Vue {
    showicon: boolean = false;
    newSubjectList: any = [];
    oldSubjectList: Subject.Subject[] = [];
    oldValue: string = "";
    subOldVal: string = "";
    @Prop({ type: String })
    accountKey!: string;

    mounted() {
        this.$nextTick(() => {
            newListItem = document.querySelector(".selectList");
            this.getData();
        })
    }

    getData() {
        Vue.axios
            .get(`old/import/data?key=${this.accountKey}`)
            .then(res => {
                this.newSubjectList = res.data.newSubjectList;
                this.oldSubjectList = res.data.oldSubjectList;
            });
    }
    addColor(el: any) {
        let dataTbody: any = document.querySelectorAll("#matchSubjectTable tr");
        let trInput: any = document.querySelectorAll("#matchSubjectTable tr .cor-input");
        for (var i = 0; i < dataTbody.length; i++) {
            dataTbody[i].classList.remove("lighter-main-color-background");
        }
        el.currentTarget.classList.add("lighter-main-color-background");
        for (var i = 0; i < trInput.length; i++) {
            trInput[i].style.border = "1px #DDD solid"
        }
        for (var i = 0; i < el.currentTarget.querySelectorAll(".cor-input").length; i++) {
            el.currentTarget.querySelectorAll(".cor-input")[i].style.border = "1px #999 solid";
        }
    }
    addBGC(el: any, data: Subject.Subject) {
        this.oldValue = el.currentTarget.value;
        let vem = this
        el.currentTarget.style.backgroundColor = "white";
        let tr = el.currentTarget.parentNode;
        let sTop: any = document.querySelector("#matchSubjectTable");
        let result = tr.offsetTop - sTop.scrollTop;
        //定位下拉框
        if (tr.querySelector(".selectList") == null) {
            tr.appendChild(newListItem);
        }
        newListItem.style.display = "block";
        let ulHeight = tr.querySelector(".selectList").offsetHeight;
        if (result > 307) {
            newListItem.style.top = -"4" - ulHeight + "px";
        } else {
            newListItem.style.top = "36px";
        }

        //下拉框点击
        let lis = newListItem.querySelectorAll("li");
        for (var i = 0; i < lis.length; i++) {
            lis[i].onclick = function () {
                this.parentNode.parentNode.querySelector("input").value = this.innerHTML;
                data["matchSubject"] = JSON.parse(this.getAttribute("item"));
                vem.$store.dispatch("setTip", {
                    text: "",
                    left: 0,
                    top: 0,
                    show: false
                });
                Vue.axios
                    .post(`old/import/subject/match?key=${vem.accountKey}`, data)
                    .then(res => {
                        vem.getData();
                    }, res => {
                        data["matchSubject"] = "";
                    });
            }
        }
    }
    async clearMatch(data: Subject.Subject) {
        data["matchSubject"] = null;
        await Vue.axios.post(`old/import/subject/match?key=${this.accountKey}`, data);
        this.getData();
    }
    reBGC(el: any, data: Subject.Subject) {
        el.currentTarget.style.backgroundColor = "";
        if (el.currentTarget.value == "" && this.oldValue != "") {
            this.clearMatch(data);
        } else {
            el.currentTarget.value = this.oldValue;
        }
        let td = el.currentTarget.parentNode;
        setTimeout(() => {
            let childNode = td.querySelector(".selectList");
            if (childNode != null) {
                td.removeChild(childNode);
            }
        }, 200)
    }
    //添加下级科目
    singleAdd(el: any, data: Subject.Subject, index: number) {
        let tempData = {
            no: "",
            text: "",
            pno: "",
            isInit: 0,
            isAdd: true
        };
        Vue.axios
            .get(`old/import/subject/no?key=${this.accountKey}&pno=${data.no}`)
            .then(res => {
                tempData["no"] = res.data.childNo;
                tempData["pno"] = data.no;
                let num = index + res.data.childNum;
                this.newSubjectList.splice(num, 0, tempData);
                this.$forceUpdate();
                this.$nextTick(() => {
                    let longTextInput: any = document.querySelectorAll("#matchSubjectTable tr")[num].querySelector(".cor-input");
                    longTextInput.focus();
                    // 光标离开添加
                    longTextInput.onblur = () => {
                        if (longTextInput.value == "") {
                            this.newSubjectList.splice(num, 1);
                        } else {
                            tempData["text"] = longTextInput.value;
                            Vue.axios
                                .post(`old/import/subject/add?key=${this.accountKey}`, tempData)
                                .then(res => {
                                    if (res.status == 200) {
                                        // this.newSubjectList.splice(num, 1, res.data);
                                        this.getData();
                                    }
                                    longTextInput.onblur = undefined;
                                }, res => {
                                    this.newSubjectList.splice(num, 1);
                                    longTextInput.onblur = undefined;
                                });
                        }
                    }
                })
            });
    }
    //删除下级科目
    delSub(data: Subject.Subject, index: number) {
        Vue.axios
            .post(`old/import/subject/delete?key=${this.accountKey}`, data)
            .then(res => {
                if (res.status == 200) {
                    // this.newSubjectList.splice(index, 1);
                    this.getData();
                }
            });
    }
    //
    getOldVal(el: any) {
        this.subOldVal = el.currentTarget.value;
    }
    //修改下级科目
    async changeSub(data: Subject.Subject, force?: boolean) {
        if (this.subOldVal != "" || force) {
            await Vue.axios.post(`old/import/subject/modify?key=${this.accountKey}`, data);
        }
    }

    // 编辑辅助核算/数量外币
    editVisible = false;
    currentSub: Subject.Subject | null = null;
    clickEdit(subject: Subject.Subject) {
        this.currentSub = subject;
        this.editVisible = true;
    }
    closeEdit() {
        this.editVisible = false;
        this.currentSub = null;
    }
    async confirmEdit(subject: Subject.Subject) {
        try {
            await this.changeSub(subject, true);
        } finally {
            this.closeEdit();
            this.getData();
        }
    }

}
